import { useContext, useState } from "react";
import Checkbox from "../../components/checkbox/checkbox.component";
import { Link } from "react-router-dom";

import WarningBox from "components/warning-box/warning-box.component";

import { AuthContext } from "../../contexts/auth.context";

import useTranslate from "../../hooks/use-translate";

import "./login.style.scss";

const ERROR_CODES = {
	401: "email is wrong",
	402: "password is wrong",
};

const Login = () => {
	const { login } = useContext(AuthContext);
	const t = useTranslate("Login");

	const [error, setError] = useState(null);

	const handleSubmit = async (event) => {
		event.preventDefault();
		const {
			email,
			password,
			// checkbox
		} = event.target;

		if (email.value.length > 0 && password.value.length > 0) {
			const error = await login({ email: email.value, password: password.value });
			setError(error);
			// if (error) alert(ERROR_CODES[error]);
		}
	};

	return (
		<div className="login-container">
			<div className="login-left-side">
				<img src={require("../../assets/login_image.png")} alt="login" />
				{/* // PLACEHOLDER //
				<br />
				// ADVERTISEMENT //
				<br />
				// IMAGE //
				<br />
				// LOGO //
				<br />
				// INTRO // */}
			</div>
			<form className="login-right-side" onSubmit={handleSubmit}>
				<div className="login-form-container">
					<span className="title">{t("welcome to metibox").toUpperCase()}</span>
					<input
						className={`text-box ${error === 401 && "error"}`}
						type="text"
						placeholder={t("email")}
						name="email"
					/>
					<input
						className={`text-box ${error === 402 && "error"}`}
						type={`password`}
						placeholder={t("password")}
						name="password"
					/>
					<div className="flex flex--space-between-content flex--center-items padding-l--bottom">
						<Checkbox label={<p className="size500">{t("remember me")}</p>} />
						<Link className="forgot-password size500" to={"/forgot-password"}>
							{t("forgot password?")}
						</Link>
					</div>
					<div className="flex flex--start-items">
						{error && <WarningBox text={ERROR_CODES[error]} />}
						<button
							className="btn btn--red size500 w500 padding-s--block padding-xxl--inline margin-auto--left"
							type="submit"
						>
							{t("login").toUpperCase()}
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};

export default Login;
